import { observable } from "mobx";
import { IndicadorService } from "../../../services";
import { getMensagemDeErro } from "../../../utils/functions";

export default class QuantidadePercentualSolicitacaoJustificativaStore {
    @observable erro;
    @observable carregando;
    @observable dadosProrrogacao;
    @observable dadosSubstituicao;
    @observable dadosDemandaComplementar;
    @observable activeTab;

    constructor() {
        this.indicadorService = new IndicadorService();

        this.activeTab = '1';
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findQuantidadePercentualSolicitacaoJustificativa(filtro).then(response => {
            if (_.find(response.data, { tipo: 'Prorrogação' })) {
                this.dadosProrrogacao = [{
                    nome: "Prorrogação",
                    "1-10": this.getQuantidadePorGrupoETipo(response.data, 'Prorrogação', 'PRORROGACAO_1_10'),
                    "11-30": this.getQuantidadePorGrupoETipo(response.data, 'Prorrogação', 'PRORROGACAO_11_30'),
                    ">30": this.getQuantidadePorGrupoETipo(response.data, 'Prorrogação', 'PRORROGACAO_31'),
                    "1-10-percentual": this.getPercentualPorGrupoETipo(response.data, 'Prorrogação', 'PRORROGACAO_1_10'),
                    "11-30-percentual": this.getPercentualPorGrupoETipo(response.data, 'Prorrogação', 'PRORROGACAO_11_30'),
                    ">30-percentual": this.getPercentualPorGrupoETipo(response.data, 'Prorrogação', 'PRORROGACAO_31')
                }]
            } else {
                this.dadosProrrogacao = []
            }

            const substituicoes = response.data.filter(d => d && d.tipo === 'Substituição');
            this.dadosSubstituicao = _.uniqBy(substituicoes, 'justificativa').map(dado => ({
                nome: dado.justificativa,
                "1-30": this.getQuantidadePorGrupoETipo(response.data, 'Substituição', 'SUBSTITUICAO_1_30', dado.justificativa),
                ">30": this.getQuantidadePorGrupoETipo(response.data, 'Substituição', 'SUBSTITUICAO_31', dado.justificativa),
                "31-90": this.getQuantidadePorGrupoETipo(response.data, 'Substituição', 'SUBSTITUICAO_31_90', dado.justificativa),
                ">90": this.getQuantidadePorGrupoETipo(response.data, 'Substituição', 'SUBSTITUICAO_91', dado.justificativa),
                "1-30-percentual": this.getPercentualPorGrupoETipo(response.data, 'Substituição', 'SUBSTITUICAO_1_30', dado.justificativa),
                ">30-percentual": this.getPercentualPorGrupoETipo(response.data, 'Substituição', 'SUBSTITUICAO_31', dado.justificativa),
                "31-90-percentual": this.getPercentualPorGrupoETipo(response.data, 'Substituição', 'SUBSTITUICAO_31_90', dado.justificativa),
                ">90-percentual": this.getPercentualPorGrupoETipo(response.data, 'Substituição', 'SUBSTITUICAO_91', dado.justificativa)
            }))

            const demandasComplementares = response.data.filter(d => d && d.tipo === 'Demanda complementar');
            this.dadosDemandaComplementar = _.uniqBy(demandasComplementares, 'justificativa').map(dado => ({
                nome: dado.justificativa,
                "1-30": this.getQuantidadePorGrupoETipo(response.data, 'Demanda complementar', 'DEMANDA_COMPLEMENTAR_1_30', dado.justificativa),
                "31-90": this.getQuantidadePorGrupoETipo(response.data, 'Demanda complementar', 'DEMANDA_COMPLEMENTAR_31_90', dado.justificativa),
                ">90": this.getQuantidadePorGrupoETipo(response.data, 'Demanda complementar', 'DEMANDA_COMPLEMENTAR_91', dado.justificativa),
                "1-30-percentual": this.getPercentualPorGrupoETipo(response.data, 'Demanda complementar', 'DEMANDA_COMPLEMENTAR_1_30', dado.justificativa),
                "31-90-percentual": this.getPercentualPorGrupoETipo(response.data, 'Demanda complementar', 'DEMANDA_COMPLEMENTAR_31_90', dado.justificativa),
                ">90-percentual": this.getPercentualPorGrupoETipo(response.data, 'Demanda complementar', 'DEMANDA_COMPLEMENTAR_91', dado.justificativa)
            }))

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    getQuantidadePorGrupoETipo = (dados, tipo, grupo, justificativa = null) => {
        const dado = _.find(dados, {
            tipo, grupo, justificativa
        });

        return dado ? dado.quantidade : 0;
    }

    getPercentualPorGrupoETipo = (dados, tipo, grupo, justificativa = null) => {
        const dado = _.find(dados, {
            tipo, grupo, justificativa
        });

        return dado ? dado.percentual : 0;
    }

    toggle = (tab) => {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
        }
    }
}
